import gql from 'graphql-tag';


export const getAllCatalogue = gql`

subscription getCatalogue {
  catalogue_categories(where:{status: {_eq: "ACTIVE"}}){
    id
    name
    catalogues(limit:8,order_by: {created_at: desc }, where: {status: {_eq: "APPROVED"}, catalogue_status: {_eq: "ACTIVE"}}){
    id
    title
    thumbnail_image
    dental_supplier{
    name
    }
   
  }
  }
}

`;

export const getAllCatalogueData = gql`
  query getFilteredCatalogueData($search: String!) {
    catalogue_categories(
      where: {
        status: {_eq: "ACTIVE"},
        catalogues: {
          dental_supplier: {
            name: {_ilike: $search}
          }
        }
      }
      
    ) {
      id
      name
      catalogues(
        limit: 100,
        where: {
          status: { _in: ["APPROVED", "SCHEDULED"] },
          catalogue_status: {_eq: "ACTIVE"},
          dental_supplier: {
            name: {_ilike: $search}
          }
        }
      ) {
        id
        title
        thumbnail_image
        dental_supplier {
          name
        }
        catalogue_sub_category {
          id
          name
        }
        catalogue_favorites {
          catalogue_id
          dental_supplier_id
          dental_practice_id
          dental_professional_id
        }
      }
    }
  }
`;



export const getAllCataloguePaginator = gql`

subscription getAllCataloguePaginator ($limit: Int, $offset: Int) {
  catalogue_categories(where: {limit: $limit, offset: $offset}){
    id
    name
    catalogues(limit:8,where: {status: {_eq: "APPROVED"}, catalogue_status: {_eq: "ACTIVE"}}){
    id
    title
    thumbnail_image
   
    
  }
  }
 
}

`;


export const relCats = gql`
query relCats($type: String!){
  catalogues(where: {type: {_eq: $type}}){
      id
      title
      thumbnail_image
      catalogue_category{
        id
        name
      }
    }
  }
`;

export const getRelatedTags = gql`

query getRelatedTags($where: catalogues_bool_exp!)  {
  catalogues(where: $where){
    id
    title
    dental_supplier_id
    thumbnail_image
    community_id

    catalogue_favorites{
      id
      catalogue_id
      type
      dental_supplier_id
      dental_professional_id
      dental_practice_id
    }
      
    catalogue_category{
      id
      name
    }

    dental_supplier{
    name
    business_name
    }
    
  }
}

`;


export const getCatalogueById = gql`
query getCatalogueById($id: uuid!){
    catalogues_by_pk(id:$id){
    id
    title
    dental_supplier_id
    attachment
    thumbnail_image
    community_id
    community_user_type
    views
    catalogue_category_id
    catalogue_category{
      id
      name
    }

  }
}
`;



export const getCatalogueTagsById = gql`
query getCatalogueTagsById($id: uuid!){
  catalogue_tags_by_pk(id:$id){
    id
    name
    j_catalogues_catalogue_tags{
      id
      catalogue_id
      catalogue_tag_id
    }

  }
}
`;


export const getSelCats = gql`
query get_related_catalogues($tagIdArray: [uuid!]){
  catalogues(where:{j_catalogues_catalogue_tags:{catalogue_tag_id:{_in: $tagIdArray}}}){
    id
    title
    thumbnail_image
  }
}
`;

export const getCompanyCatelogAll = gql`
query getCompanyCatelogAll($id: uuid!){
    catalogues(where:{dental_supplier_id:{_eq:$id},status: {_eq: "APPROVED"}, catalogue_status: {_eq: "ACTIVE"}}) {
    id
    title
    dental_supplier_id
    thumbnail_image

    catalogue_favorites{
      id
      catalogue_id
      type
      dental_supplier_id
      dental_professional_id
      dental_practice_id
    }

    catalogue_category{
      id
      name
    }
   
  }
}
`;

export const getCatalogueCategoriesFront = gql`

subscription getCatalogueCategoriesFront {
  catalogue_categories(where:{status: {_eq: "ACTIVE"}}){
    id
    name
  }
}

`;
export const getCatalogueSubCategoriesFront = gql`

subscription getCatalogueSubCategoriesFront {
  catalogue_sub_categories(where:{status: {_eq: "ACTIVE"}}){
    id
    name
  }
}

`;


export const updateCataloguesViewsMutation = gql`mutation update_catalogues_by_pk($id: uuid! ,$cataloguesViews: catalogues_set_input!){
  update_catalogues_by_pk(pk_columns:{id: $id}, _set: $cataloguesViews){
    id
  }
}`;



// export const getCatalogueSubCategoriesFrontload = gql`
//   query getCataloguesByCategory($id: uuid!) {
//     catalogues(
//       where: {
//         catalogue_category_id: { _eq: $id },
//         status: { _in: ["APPROVED", "SCHEDULED"] },
//         catalogue_status: { _eq: "ACTIVE" }
//       }
//     ) {
//       id
//       title
//       thumbnail_image
//       dental_supplier_id
//       catalogue_favorites {
//         id
//         catalogue_id
//         type
//         dental_supplier_id
//         dental_professional_id
//         dental_practice_id
//       }
//       catalogue_category {
//         id
//         name
//       }
//       dental_supplier {
//         name
//       }
//       catalogue_sub_category {
//         id
//         name
//       }
//     }
//   }
// `;
export const getCataloguesByCategory = gql`
  query getCataloguesByCategory($where: catalogues_bool_exp!, $limit: Int!, $offset: Int!) {
    catalogues(
    where: $where,      
    limit: $limit
    offset: $offset
    order_by: { created_at: desc }
    ){
      id
      title
      thumbnail_image
      dental_supplier_id
      community_user_type
      catalogue_favorites {
        id
        catalogue_id
        type
        dental_supplier_id
        dental_professional_id
        dental_practice_id
      }
      catalogue_category {
        id
        name
      }
      dental_supplier {
        name
        business_name
      }
      catalogue_sub_category {
        id
        name
      }
    }
  }
`;

export const getCataloguesForAllTabQuery = gql`
  query getCataloguesForAllTab($where: catalogues_bool_exp!, $limit: Int!, $offset: Int!) {
    catalogues(
     where: $where
      limit: $limit
      offset: $offset
      order_by: { created_at: desc }
    ) {
      id
      title
      thumbnail_image
      dental_supplier_id
      catalogue_favorites {
        id
        catalogue_id
        type
        dental_supplier_id
        dental_professional_id
        dental_practice_id
      }
      catalogue_category {
        id
        name
      }
      dental_supplier {
        name
        business_name
      }
      catalogue_sub_category {
        id
        name
      }
    }
  }
`;


export const getAllCatalogueSupplierName = gql`
query getAllCatalogueSupplierName {
  catalogues(
    distinct_on: dental_supplier_id
    order_by: [
      { dental_supplier_id: asc }
      { created_at: desc }
    ]
    where: {
      status: { _in: ["APPROVED", "SCHEDULED"] }
      catalogue_status: { _eq: "ACTIVE" }
    }
  ) {
    dental_supplier {
      id
      business_name
      community_id
    }
  }
}

`;

export const getMyCatalogueData = gql`
    query getMyCatalogueData($where: catalogues_bool_exp!) {
      catalogues(where: $where) {
        id
        title
        dental_supplier_id
        community_id
        community_status
        community_user_type
        thumbnail_image
        status
        catalogue_status
        title
        catalogue_sub_category{
        name
        }
        dental_supplier{
        business_name 
        }
      }
    }
  `;

  export const supplierData = gql`
query supplierDisplay($id: uuid!){
    dental_suppliers_by_pk(id:$id){
    id
    community_id
  }
}
`;